const route = [
  {
    path: '/dashboardLOP',
    name: 'dashboardLOP',
    meta: { authRequired: true },
    component: () => import('./Dashboard.vue')
  },
];

module.exports = {
  route
};
